import React from 'react';

const YellowPumpIcon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 99.324 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M33.896,18.919l5.292-8.559l0.676,6.532L33.896,18.919z" />
	<radialGradient id={`${uid}_2`} cx="49.6621" cy="62.7246" r="49.6621" gradientUnits="userSpaceOnUse">
		<stop offset="0.68" style={{stopColor: `${endColor}`}} />
		<stop offset="0.84" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</radialGradient>
	<circle fill={`url(#${uid}_2)`} cx="49.662" cy="62.725" r="49.662" />
	<circle fill={`${endColor}`} cx="49.662" cy="62.725" r="34.009" />
	
		<radialGradient id={`${uid}_3`} cx="49.6621" cy="49.7744" r="23.5361" gradientTransform="matrix(1 0 0 -1 0 112.5)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</radialGradient>
	<circle fill={`url(#${uid}_3)`} cx="49.662" cy="62.726" r="23.536" />
</g>
<g id={`${uid}_4`}>
	
		<radialGradient id={`${uid}_5`} cx="67.9639" cy="53.7144" r="41.415" gradientTransform="matrix(1 0 0 -1 0 112.5)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</radialGradient>
	<path fill={`url(#${uid}_5)`} stroke={`${endColor}`} strokeWidth="0.1" d="M60.135,12.951v-5.18H39.189v5.18l0.451,4.167l1.351,3.941   l2.252,3.604l2.815,3.153l3.604,2.703l1.352,0.789l6.756,1.126l3.604,1.239l3.492,1.689l3.266,2.14l2.929,2.365l2.59,2.815   l2.252,3.041l1.914,3.266l1.465,3.604l1.014,3.716l0.676,3.83v4.166l-0.338,3.266l-0.563,3.041l-0.901,2.929l-1.237,2.815   l-1.465,2.59l-1.689,2.59l-2.928,3.379l-3.49,3.04l-2.479,1.688l-2.59,1.465l-2.928,1.125l-2.93,0.901l-3.039,0.677l-3.153,0.338   h-1.576V109.8h2.364l4.729-0.45l4.617-1.014l4.394-1.352l4.278-1.803l4.054-2.139l3.717-2.591l3.492-2.815l3.151-3.266l2.929-3.49   l2.479-3.717l2.252-4.055l1.801-4.166l1.352-4.394l0.901-4.616l0.563-4.729v-2.479V61.15l-0.451-4.617l-0.45-3.041l-0.788-3.041   l-0.9-2.928l-1.127-2.815l-1.237-2.815l-1.466-2.815l-1.575-2.59l-1.802-2.477l-1.914-2.365L81.76,28.38l-2.252-2.14l-2.477-1.802   l-2.592-1.802l-1.351-0.788l-9.01-4.279l-2.929-2.027L60.135,12.951z" />
</g>
<g id={`${uid}_6`}>
	
		<radialGradient id={`${uid}_7`} cx="49.6621" cy="49.7749" r="13.0627" gradientTransform="matrix(1 0 0 -1 0 112.5)" gradientUnits="userSpaceOnUse">
		<stop offset="0.47" style={{stopColor: `${startColor}`}} />
		<stop offset="0.54" style={{stopColor: `${midColor}`}} />
		<stop offset="0.99" style={{stopColor: `${startColor}`}} />
	</radialGradient>
	<circle fill={`url(#${uid}_7)`} cx="49.662" cy="62.725" r="13.063" />
</g>
<g id={`${uid}_8`}>
	<path fill={`${endColor}`} d="M35.248,77.141l-0.676-1.465l0.676-1.576l1.464-0.676l1.577,0.676l0.676,1.576l-0.676,1.465l-1.577,0.676   L35.248,77.141z" />
	<path fill={`${endColor}`} d="M35.248,51.464l-0.676-1.577l0.676-1.576l1.464-0.563l1.577,0.563l0.676,1.576l-0.676,1.577l-1.577,0.563   L35.248,51.464z" />
	<path fill={`${endColor}`} d="M60.924,51.464l-0.563-1.577l0.563-1.576l1.576-0.563l1.576,0.563l0.563,1.576l-0.563,1.577L62.5,52.027   L60.924,51.464z" />
	<path fill={`${endColor}`} d="M60.924,77.141l-0.563-1.465l0.563-1.576l1.576-0.676l1.576,0.676l0.563,1.576l-0.563,1.465L62.5,77.814   L60.924,77.141z" />
	<path fill={`${endColor}`} d="M44.031,102.365l-2.14-5.631l2.14-5.519l5.631-2.253l5.631,2.253l2.252,5.519l-2.252,5.631l-5.631,2.252   L44.031,102.365z" />
	<radialGradient id={`${uid}_9`} cx="49.7178" cy="93.5254" r="7.8267" gradientUnits="userSpaceOnUse">
		<stop offset="0.45" style={{stopColor: `${endColor}`}} />
		<stop offset="0.84" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</radialGradient>
	<path fill={`url(#${uid}_9)`} stroke={`${endColor}`} strokeWidth="0.1" d="M44.031,99.1l-2.14-5.631l2.14-5.519l5.631-2.252l5.631,2.252   l2.252,5.519L55.293,99.1l-5.631,2.252L44.031,99.1z" />
</g>
<g id={`${uid}_10`}>
	
		<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="12.9502" y1="3.9414" x2="86.2617" y2="3.9414" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} stroke={`${startColor}`} strokeWidth="0.25" d="M12.95,112.5v-7.883h28.829v3.266h15.766v-3.266h28.717v7.883   H12.95z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M73.197,104.617h5.293v7.883h-5.293V104.617z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M20.833,104.617h5.292v7.883h-5.292V104.617z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M41.779,107.883h15.766v4.617H41.779V107.883z" />
</g>
<g id={`${uid}_12`}>
	
		<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="31.3062" y1="108.6143" x2="68.0176" y2="108.6143" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} d="M31.306,7.771h36.711V0H31.306V7.771" />
</g>
    </svg>
  );
};

export default YellowPumpIcon;
